import React from 'react';
import './404.style.sass';
import BG from '../../assets/image/design1.png';

const Page404 = () => {
    return (
        <div className='page404'>
            <div>
                <h3 className='page404-title'>404 صفحه مورد نظر یافت نشد</h3>
                <div className='page404-detail-div'>
                    <p className='page404-detail'>مشکلی در باز شدن سایت پیش آمده است، همکاران درحال برسی هستند.</p>
                    <p className='page404-detail'>از شکیبایی شما سپاسگزاریم</p>
                    <br/>
                    <a href='/' className='page404-back'>بازگشت به صفحه اصلی</a>
                </div>
            </div>

            <img src={BG} alt='xitonix satellite'/>
        </div>
    );
};

export default Page404;